import { useDestinations } from '@/hooks/useDestinations';
import type { MedicalProvider } from '@/services/types/treatment-types';
import type {
  DestinationScope,
  ScopeDestinationBlock,
} from '@/types/provider-destinations';

interface UseProviderDestinationsResult {
  scopes: ScopeDestinationBlock[];
  getScopeDestinations: (
    scope: DestinationScope,
  ) => ScopeDestinationBlock | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
  providerServiceId: string | null;
  isLinked: boolean;
}

export const useProviderDestinations = (
  provider: MedicalProvider,
): UseProviderDestinationsResult => {
  const providerServiceId = provider.provider_service_ref_id ?? null;
  const destinations = useDestinations(providerServiceId ?? '');

  return {
    ...destinations,
    providerServiceId,
    isLinked: Boolean(providerServiceId),
  };
};
